import React from 'react'
import { connect } from 'react-redux'
import { Row, Col, Icon } from 'antd'
import { message } from 'antd'

import SyntaxHighlighter from 'react-syntax-highlighter'
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const CodeHilight = ({ code }) => {
    return (
        <div style={{ position: 'relative' }}>
            <CopyToClipboard text={code} onCopy={() => message.success('Copied code.')}>
                <Icon type="copy" style={{ cursor: 'pointer', position: 'absolute', top: 10, right: 10 }} />
            </CopyToClipboard>
            <SyntaxHighlighter language="html" style={docco} customStyle={{ paddingTop: 15 }}>
                {code}
            </SyntaxHighlighter>
        </div>
    )
}

class NowInstallCustom extends React.Component {
    render() {
        const { applicationId } = this.props

        const tagCode = `<script>
    var application_id = '${applicationId ? applicationId : 'INSERT YOUR APPLICATION ID HERE'}';
    (function (w,d,n,u) {
        w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)};
        var a=d.createElement("script");
        a.type="text/javascript",a.async=1,a.src=u;
        var b=d.getElementsByTagName("script")[0];
        b.parentNode.insertBefore(a,b)
    })(window,document,'ekkoNow','//static.ekko.chat/now/ekkonow.min.js');
    ekkoNow('init', application_id);
</script>`

        return (
            <Row>
                <Col xs={22} sm={18} md={14}>
                    <h2 style={{ paddingTop: 30, marginBottom: 20 }}>
                        To use Ekko, juste copy and paste this snippet in your website's header.
                    </h2>
                </Col>

                <Col xs={0} sm={20} md={18} xl={16}>
                    <CodeHilight code={tagCode} />
                </Col>

                <Col xs={22} sm={18} md={14}>
                    <a href="http://docs.ekko.chat/docs/now/now_custom" target="_blank" style={{ color: "inherit" }}>
                        <span style={{ marginLeft: 30, fontSize: 18 }}> Let's see how to custom your widget Now </span>
                        <Icon style={{ marginLeft: 10 }} type="arrow-right"  />
                    </a>
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = ({ ekko }) => ({
    applicationId: ekko.currentAppId
})

export default connect(
    mapStateToProps,
    null
)(NowInstallCustom)
